export default __webpack_public_path__ + "static/TCP-Logo-1x-db103ea0f11d4159e2bf6015ac127017.png";